<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="bg-primary nav303" >
                <template #default>   <m-nav-303 v-bind='{...{"shoppingCart":true,"menuPosition":"store_nav"},...{}}' :style='""' class="mx-auto  p-4" >
                <template #default>default   </template>
                </m-nav-303></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background: var(--secondary);"' class="py-2 sticky-top mini-sticky-nav d-none  d-md-block" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container-fluid" >
                <template #default>   <m-menu-1 v-bind='{...{"menuPosition":"blog_nav"},...{}}' :style='""' class="text-center" >
                <template #default>   </template>
                </m-menu-1></template>
                </m-div></template>
                </m-div><m-nav-305 v-bind='{...{"shoppingCartToggleTo":null,"activeSms":"true","menuPosition":"blog_nav"},...{}}' :style='""' class="" ></m-nav-305><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='""' class="f100" >
                <template #default>   <m-footer-100 v-bind='{...{"menuPosition":"store_footer"},...{}}' :style='""' class="py-5" >
                <template #default>default   </template>
                </m-footer-100></template>
                </m-div><m-shopping-cart-2 v-bind='{...{"haveItem":"https:\/\/api.rangaab.ir\/storage\/assets\/shopping-cart-fill.svg","empty":"https:\/\/api.rangaab.ir\/storage\/assets\/shopping-cart-empty.svg"},...{}}' :style='""' class="sticky-shopping" ></m-shopping-cart-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav303 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav303/Nav303'; import mMenu1 from '@moeinmdn/miw-alpha-components/src/package/Menu/Menu1'; import mNav305 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav305/Nav305'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mFooter100 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer100/Footer100'; import mShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mNav303,mMenu1,mNav305,mLoading3,mUpdateSiteMessage1,mFooter100,mShoppingCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
